import { useCallback, useMemo } from "react";
import ReleaseManagementComponent from "../components/ReleaseManagementComponent";
import { firmwareList, updateFirmware } from "../../../../Service/Api/firmware";
import { useDebouncedApiCall, usePaginationCore } from "../../../../hooks";
import { useNavigate } from "react-router";
import { compareVersions } from "../utils/compareVersions";
import { firmwareTableCols } from "../constants";

const FirmwareContainer = () => {
  const { call } = useDebouncedApiCall();

  const {
    data: rowList,
    count,
    updateRow,
    paginationUI
  } = usePaginationCore({
    pageName: "Firmware",
    fetchFn: firmwareList,
    // deleteFn: deleteFirmwareById,
  });

  const updateClick = useCallback(
    (e, id) => {
      e?.preventDefault();
      call(async () => {
        const res = await updateFirmware({ latest: true }, id);
        if (!res.error) {
          const findLatest = rowList.filter((row) => row.latest === true);
          updateRow([
            { id, latest: true },
            { id: findLatest[0].id, latest: false },
          ]);
        }
        return res;
      });
    },
    [call, updateRow, rowList]
  );

  const memoizedProps = useMemo(
    () => ({
      rowList: rowList.sort((a, b) => compareVersions(b, a)),
      updateClick,
      tableCols:firmwareTableCols,
      paginationUI
    }),
    [rowList,paginationUI]
  );

  return <ReleaseManagementComponent {...memoizedProps} />;
};

export default FirmwareContainer;
